export const FIREFLY_DOCUMENTATION = "https://firefly-5.gitbook.io/firefly-documentation-portal"